
import React from "react";
import { Calendar, Camera, Edit, Bot } from "lucide-react";

const TocTocHowItWorks = () => {
  const steps = [
    {
      icon: Calendar,
      title: "1. Agendamento",
      description: "Entre em contato e agendamos a visita no melhor horário para você",
      details: ["Consulta gratuita", "Planejamento estratégico", "Horário flexível"]
    },
    {
      icon: Camera,
      title: "2. Sessão Fotográfica",
      description: "Nossa equipe realiza a sessão com equipamentos profissionais",
      details: ["Iluminação especializada", "Múltiplos ângulos", "Captura de detalhes"]
    },
    {
      icon: Edit,
      title: "3. Edição Profissional",
      description: "Tratamento cuidadoso das imagens mantendo a naturalidade",
      details: ["Correção de cores", "Otimização de luz", "Acabamento premium"]
    },
    {
      icon: Bot,
      title: "4. Entrega Rápida",
      description: "Receba suas fotos editadas e em alta resolução em até 48 horas",
      details: ["Download online", "Múltiplos formatos", "Uso irrestrito"]
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center mb-16 animate-[fadeInUp_0.8s_ease-out_0.2s_both]">
          <h2 className="text-3xl md:text-4xl font-bold text-[#323031] mb-6">
            Como <span className="text-[#FF5605]">funciona</span>?
          </h2>
          <p className="text-lg text-[#5B5A59] max-w-3xl mx-auto">
            Um processo simples e eficiente que transforma seu imóvel em uma apresentação irresistível.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div 
              key={index}
              className={`etapa-${index + 1} relative group animate-[fadeInLeft_0.8s_ease-out_${0.1 + (index * 0.2)}s_both]`}
            >
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-full w-full h-0.5 bg-gradient-to-r from-[#FF5605] to-transparent z-0"></div>
              )}
              
              <div className="relative bg-white border border-gray-100 rounded-2xl p-6 group-hover:shadow-xl transition-all duration-300 hover:-translate-y-2 z-10">
                <div className="w-16 h-16 bg-[#FF5605]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#FF5605]/20 transition-colors mx-auto group-hover:scale-110 transform duration-300">
                  <step.icon className="h-8 w-8 text-[#FF5605]" />
                </div>
                
                <h3 className="text-lg font-bold text-[#323031] mb-3 text-center">
                  {step.title}
                </h3>
                
                <p className="text-[#5B5A59] text-center mb-4">
                  {step.description}
                </p>
                
                <ul className="space-y-2">
                  {step.details.map((detail, idx) => (
                    <li key={idx} className="flex items-center text-sm text-[#5B5A59]">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#FF5605] mr-3 animate-pulse"></div>
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-gradient-to-r from-[#261E13] to-[#323031] rounded-2xl p-8 md:p-12 text-white animate-[fadeInUp_0.8s_ease-out_0.8s_both]">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-6">
                Resultados que impressionam
              </h3>
              <p className="text-lg text-white/90 mb-8">
                Nossa metodologia comprovada transforma qualquer espaço em uma apresentação 
                profissional que conecta emocionalmente com potenciais compradores.
              </p>
              
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#FF5605] mb-2 animate-[pulse_2s_infinite]">48h</div>
                  <div className="text-sm text-white/80">Entrega garantida</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#FF5605] mb-2 animate-[pulse_2s_infinite_0.5s]">100%</div>
                  <div className="text-sm text-white/80">Satisfação</div>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <div className="rounded-xl overflow-hidden shadow-2xl animate-[scaleIn_0.8s_ease-out_1s_both]">
                <img 
                  src="/lovable-uploads/1b94ad33-6f76-48f1-b058-c35405190cf2.png" 
                  alt="Resultado fotografia imobiliária profissional - Antes e depois edição premium Balneário Camboriú" 
                  loading="lazy"
                  width="600"
                  height="400"
                  className="w-full h-64 object-cover"
                />
              </div>
              
              <div className="absolute -top-4 -right-4 bg-[#FF5605] text-white px-4 py-2 rounded-full font-medium shadow-lg animate-[bounce_1s_infinite_1.5s]">
                ✨ Resultado profissional
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TocTocHowItWorks;
